<template>
  <div class="captcha-wrapper">
    <vue-recaptcha
      ref="recaptchaInner"
      :sitekey="recaptchaSitekey"
      :load-recaptcha-script="true"
      size="invisible"
      @verify="onCaptchaVerify"
      @expired="onCaptchaExpire"
      @error="onRecaptchaError"
    />
  </div>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha'
import * as Bugsnag from '@bugsnag/js'

export default {
  name: 'CaptchaBlock',
  components: {
    'vue-recaptcha': VueRecaptcha,
  },
  props: {
    keyType: { type: String, required: true },
  },
  computed: {
    recaptchaSitekey() {
      switch (this.keyType) {
        case 'login':
          return process.env.VUE_APP_INVISIBLE_RECAPTCHA_SITEKEY
        case 'subscriptions':
          return process.env.VUE_APP_INVISIBLE_SUBSCRIPTIONS_RECAPTCHA_SITEKEY
        default:
          return ''
      }
    },
  },
  methods: {
    execute() {
      this.$store.dispatch('app/setIsLoadingCaptcha', true)
      const widget = this.$refs.recaptchaInner
      if (widget && typeof widget.execute === 'function') {
        widget.execute()
      } else {
        this.sendBugsnagNotification({
          stage: 'not_ready',
          details: 'Recaptcha widget not ready',
        })
      }
    },
    onCaptchaVerify(token) {
      this.$store.dispatch('app/setIsLoadingCaptcha', false)
      // Do not send the token to Bugsnag; treat it as a secret
      this.sendBugsnagNotification({ stage: 'verified' })
      this.$emit('captcha-verify-action', { recaptcha: token })
    },
    onCaptchaExpire() {
      this.$store.dispatch('app/setIsLoadingCaptcha', false)
      this.sendBugsnagNotification({ stage: 'expired' })
    },
    onRecaptchaError(error) {
      this.$store.dispatch('app/setIsLoadingCaptcha', false)
      this.sendBugsnagNotification({
        stage: 'error',
        details: error ? String(error) : 'reCAPTCHA failed to load',
      })
    },
    // Send a Bugsnag notification for reCAPTCHA lifecycle events
    // IMPORTANT: never send the token to Bugsnag (treat it as secret)
    sendBugsnagNotification({ stage, details } = {}) {
      const notificationData = {
        message: `reCAPTCHA ${stage}`,
        data: {
          stage,
          details: details || null,
          timestamp: new Date().toISOString(),
        },
      }

      Bugsnag.addMetadata('recaptcha_event_data', notificationData)
      Bugsnag.notify(JSON.stringify(notificationData))
    },
  },
}
</script>
